export default __webpack_public_path__ + "assets/linkedin-icon-6cff9b123f95937c57d2babd3ed65686.svg";